module.exports = __webpack_public_path__ + "img/etapa1.1bbbccca.png";